import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { getStoredAuthToken } from "@/lib/backend-auth";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async ({ location }) => {
    const token = getStoredAuthToken();
    const isPublicPath = location.pathname === "/acceso" || location.pathname === "/login";

    if (typeof window !== "undefined") {
      console.log("[auth guard] beforeLoad", {
        pathname: location.pathname,
        hasToken: Boolean(token),
        isPublicPath,
      });
    }

    if (!token && !isPublicPath) {
      if (typeof window !== "undefined") {
        console.log("[auth guard] redirecting to /acceso from", location.pathname);
      }
      throw redirect({ to: "/acceso" });
    }

    return { user: { token } };
  },
  component: () => <Outlet />,
});
